import React from 'react'
import styled from 'styled-components'
import palette from 'core-system/Themes/palette'

const Pill = styled.div<{ showFullText?: boolean }>`
  display: inline-block;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  background-color: ${palette.grey.grey300};
  color: ${palette.grey.grey800};
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  max-width: ${(props) => (props.showFullText ? 'unset' : '160px')};
  text-overflow: ${(props) => (props.showFullText ? 'unset' : 'ellipsis')};
  overflow: ${(props) => (props.showFullText ? 'unset' : 'hidden')};
`

interface PillProps {
  children: React.ReactNode
  showFullText?: boolean
}

const PillContainer = ({
  children,
  showFullText = false,
  ...props
}: PillProps) => {
  return (
    <Pill showFullText={showFullText} {...props}>
      {children}
    </Pill>
  )
}

export default React.memo(PillContainer)
